import $ from "jquery";

class NewsroomLoadMore {
	constructor(options) {
		this.options = {
			buttonSelector: ".js-load-more-press",
			containerSelector: ".js-press-releases-target .js-posts-container",
			action: "load_press_releases",
			nonce: window.drAjax?.nonce,
			ajaxUrl: window.drAjax?.ajaxurl,
			...options,
		};

		this.button = document.querySelector(this.options.buttonSelector);
		this.container = document.querySelector(this.options.containerSelector);

		if (!this.button || !this.container || !this.options.ajaxUrl || !this.options.nonce) {
			return;
		}

		this.init();
	}

	init() {
		const initialPaged = parseInt(this.container.dataset.paged, 10);
		const maxPages = parseInt(this.container.dataset.max_num_pages, 10);

		this.button.addEventListener("click", this.handleClick.bind(this));

		if (initialPaged > maxPages) {
			this.button.style.display = "none";
		} else {
		}
	}

	handleClick(event) {
		event.preventDefault();

		if (this.button.disabled) {
			return;
		}

		this.showLoading(true);

		const pageToLoad = parseInt(this.container.dataset.paged, 10);
		const maxPages = parseInt(this.container.dataset.max_num_pages, 10); // Keep this for initial client-side check, but server response is king
		const postsPerPage = this.container.dataset.posts_per_page;
		const featuredIds = this.container.dataset.featured_ids;
		const categorySlug = this.container.dataset.category_slug;
		const itemTemplate = this.container.dataset.item_template;

		const formData = new FormData();
		formData.append("action", this.options.action);
		formData.append("nonce", this.options.nonce);
		formData.append("paged", pageToLoad.toString());
		formData.append("posts_per_page", postsPerPage);
		formData.append("featured_ids", featuredIds);
		formData.append("category_slug", categorySlug);
		formData.append("item_template", itemTemplate);

		fetch(this.options.ajaxUrl, {
			method: "POST",
			body: formData,
		})
			.then((response) => {
				if (!response.ok) {
					throw new Error(`Network response was not ok. Status: ${response.status}`);
				}
				return response.json();
			})
			.then((data) => {
				this.showLoading(false);
				if (data.success) {
					if (data.data.content) {
						this.container.insertAdjacentHTML("beforeend", data.data.content);
					}
					const nextPageForDataAttr = pageToLoad + 1;
					this.container.dataset.paged = nextPageForDataAttr.toString();

					// Use max_num_pages from server response to decide if button should be hidden
					const serverMaxPages = parseInt(data.data.max_num_pages, 10);
					if (nextPageForDataAttr > serverMaxPages || !data.data.content || data.data.content.trim() === "") {
						this.button.style.display = "none";
					}
				} else {
					this.button.style.display = "none";
				}
			})
			.catch((error) => {
				this.showLoading(false);
				this.button.style.display = "none";
			});
	}

	showLoading(isLoading) {
		this.button.disabled = isLoading;
		if (isLoading) {
			this.button.classList.add("disabled");
		} else {
			this.button.classList.remove("disabled");
		}
	}
}

class MediaLoadMore {
	constructor(options) {
		this.options = {
			buttonSelector: ".js-load-more-media",
			containerSelector: ".js-media-posts-target .js-posts-container",
			action: "load_press_releases", // PHP action is reusable
			nonce: window.drAjax?.nonce,
			ajaxUrl: window.drAjax?.ajaxurl,
			...options,
		};

		this.button = document.querySelector(this.options.buttonSelector);
		this.container = document.querySelector(this.options.containerSelector);

		if (!this.button || !this.container || !this.options.ajaxUrl || !this.options.nonce) {
			return;
		}

		this.init();
	}

	init() {
		const initialPagedAttr = this.container.dataset.paged;
		const maxPagesAttr = this.container.dataset.max_num_pages;

		if (initialPagedAttr === undefined || maxPagesAttr === undefined) {
			if (this.button) {
				this.button.style.display = "none";
			}
			return;
		}

		const initialPaged = parseInt(initialPagedAttr, 10);
		const maxPages = parseInt(maxPagesAttr, 10);

		this.button.addEventListener("click", this.handleClick.bind(this));

		if (initialPaged > maxPages) {
			this.button.style.display = "none";
		}
	}

	handleClick(event) {
		event.preventDefault();

		if (this.button.disabled) {
			return;
		}

		this.showLoading(true);

		const pageToLoad = parseInt(this.container.dataset.paged, 10);
		const postsPerPage = this.container.dataset.posts_per_page;
		const featuredIds = this.container.dataset.featured_ids;
		const categorySlug = this.container.dataset.category_slug;
		const itemTemplate = this.container.dataset.item_template;

		if (!categorySlug || !itemTemplate || !postsPerPage || featuredIds === undefined) {
			this.showLoading(false);
			this.button.style.display = "none";
			return;
		}

		const formData = new FormData();
		formData.append("action", this.options.action);
		formData.append("nonce", this.options.nonce);
		formData.append("paged", pageToLoad.toString());
		formData.append("posts_per_page", postsPerPage);
		formData.append("featured_ids", featuredIds);
		formData.append("category_slug", categorySlug);
		formData.append("item_template", itemTemplate);

		fetch(this.options.ajaxUrl, {
			method: "POST",
			body: formData,
		})
			.then((response) => {
				if (!response.ok) {
					throw new Error(`Network response was not ok. Status: ${response.status}`);
				}
				return response.json();
			})
			.then((data) => {
				this.showLoading(false);
				if (data.success) {
					if (data.data.content) {
						this.container.insertAdjacentHTML("beforeend", data.data.content);
					}
					const nextPageForDataAttr = pageToLoad + 1;
					this.container.dataset.paged = nextPageForDataAttr.toString();

					const serverMaxPages = parseInt(data.data.max_num_pages, 10);
					if (nextPageForDataAttr > serverMaxPages || !data.data.content || data.data.content.trim() === "") {
						this.button.style.display = "none";
					}
				} else {
					this.button.style.display = "none";
				}
			})
			.catch((error) => {
				this.showLoading(false);
				this.button.style.display = "none";
			});
	}

	showLoading(isLoading) {
		this.button.disabled = isLoading;
		if (isLoading) {
			this.button.classList.add("disabled");
		} else {
			this.button.classList.remove("disabled");
		}
	}
}

export default function () {
	$(document).ready(() => {
		if (typeof $ === "undefined") {
			return;
		}
		new NewsroomLoadMore({});

		new MediaLoadMore({});
	});
}
